import { gql } from '@apollo/client'

export default gql(`
    mutation updateBucketGroupType($id: ID! $name: String! $position: Int! $project: String ) {
        updateBucketGroupType(
            input: {
                id: $id
                name: $name
                position: $position
            }
            project: $project
        ) {
            id
            name
            position
            usedCount
        }
    }`
)
